let storage = {
  get(key, defaultValue = null) {
    return window.sessionStorage.getItem(this.formatSessionKey(key)) || defaultValue;
  },
  set(key, val) {
    window.sessionStorage.setItem(
      this.formatSessionKey(key),
      typeof val !== "string" ? JSON.stringify(val) : val
    );
  },
  del(key) {
    window.sessionStorage.removeItem(this.formatSessionKey(key));
  },
  cle() {
    window.sessionStorage.clear();
  },
  formatSessionKey(key) {
    return key
  }
};
export default storage;